// The quiet install hint: one ruled line in ink-2 with a single link. Shown in a browser tab only (never in the
// installed app): by the shell on the first launch, and in "Lisää" until dismissed for good.
import { Link, useLocation } from 'react-router';
import { Icon } from '../components/Icon';
import { useT } from '../i18n';
import { dismissInstallHint, promptInstall, showFirstLaunchBanner, showMoreBanner, useInstall } from './install';
import { INSTALL_PATH } from './nav';

export function InstallBanner({ where }: { where: 'shell' | 'more' }) {
  const t = useT();
  const s = useInstall();
  const { pathname } = useLocation();
  const show = where === 'shell' ? showFirstLaunchBanner(s) && pathname !== INSTALL_PATH : showMoreBanner(s);
  if (!show) return null;
  const ios = s.platform === 'ios-safari' || s.platform === 'ios-other';
  return (
    <aside className={`install-banner install-hint is-${where}`} aria-label={t.install.title}>
      <Icon name={ios ? 'share' : 'install'} />
      <div className="install-banner-text">
        <p>{ios ? t.install.bannerIos : t.install.bannerText}</p>
        {s.canPrompt ? (
          <button type="button" className="link-btn install-banner-go" onClick={() => void promptInstall()}>
            {t.install.installButton}
          </button>
        ) : (
          <Link to={INSTALL_PATH} className="link-btn install-banner-go">
            {t.install.bannerHow}
          </Link>
        )}
      </div>
      <div className="install-banner-actions">
        <button type="button" className="icon-btn" onClick={dismissInstallHint} aria-label={t.install.bannerDismiss} title={t.install.bannerDismiss}>
          <Icon name="close" />
        </button>
      </div>
    </aside>
  );
}
